import { Team } from '@wetransfer/transfer/hooks/useCurrentTeam/useCurrentUserTeamsQuery';
import { Sender } from '@wetransfer/transfer/types/graphql-types';

// TEAM MEMBER COLORS
const TEAM_MEMBER_PLACEHOLDER_COLORS: {
  backgroundColor: string;
  fontColor: string;
}[] = [
  {
    backgroundColor: '#FFC7B9',
    fontColor: '#9D2300',
  },
  {
    backgroundColor: '#F1E3FF',
    fontColor: '#650095',
  },
  {
    backgroundColor: '#E0EAFF',
    fontColor: '#1B44C9',
  },
  {
    backgroundColor: '#CAE8DE',
    fontColor: '#245849',
  },
  {
    backgroundColor: '#E1F4AD',
    fontColor: '#404D00',
  },
  {
    backgroundColor: '#FDEEA9',
    fontColor: '#534600',
  },
  {
    backgroundColor: '#ECDBCC',
    fontColor: '#663A00',
  },
];

export function getEmailDomain(email: string): string {
  return email.substring(email.lastIndexOf('@') + 1);
}

export let usersNotInTeam: string[] = [];

export const verifyUsersList = (
  recipients: string[],
  userEmail: string,
  currentTeam: Team
): boolean => {
  usersNotInTeam = [];

  recipients.forEach((recipient) => {
    const members = currentTeam?.members || [];
    const emailArray = members.map((member) => member.user?.email) || [];

    if (emailArray.indexOf(recipient) === -1 && userEmail !== recipient) {
      usersNotInTeam.push(recipient);
    }
  });

  return usersNotInTeam.length > 0;
};

export const getInitials = (email: string, member?: Sender): string => {
  // Link transfers by members who have left the team
  if (member === undefined) {
    return `${email.substring(0, 2).toUpperCase()}`;
  }

  if (member.familyName !== undefined && member.familyName !== null) {
    return `${member.givenName.charAt(0)}${member.familyName.charAt(0)}`;
  }

  return `${member.givenName.substring(0, 2)}`;
};

export const getMemberInitialsColors = (
  memberIndex: number
): { backgroundColor: string; fontColor: string } => {
  const memberColorIndex = memberIndex % 6;
  const memberColors = TEAM_MEMBER_PLACEHOLDER_COLORS[memberColorIndex];

  return memberColors;
};
